module.exports = __webpack_public_path__ + "3097fd1efeeaafeb6b5333ba983ca994.svg";